import React from "react";
import Modal from "react-bootstrap/Modal";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { toast } from "react-toastify";
import EditSchoolForm from "../../../Home/Forms/EditSchoolForm";
import UserBill from "../../Users/UserBill";
import UserNote from "../../Users/UserNote";
import MoreInfoModal from "../../Users/components/MoreInfoModal";
import configDataCountries from "../../../Config/countries.json";

const SchoolModals = ({
    activeModal,
    selectedSchool,
    schoolUsers,
    loadingSchoolUsers,
    activeAdminUser,
    setActiveAdminUser,
    countries,
    onClose,
    onSubmitAdd,
    onSubmitEdit,
    onAction,
    t,
}) => {
    return (
        <>
            {/* Add School Modal */}
            {activeModal === "add" && (
                <Modal
                    size="lg"
                    centered
                    backdrop="static"
                    keyboard={false}
                    enforceFocus={false}
                    show={activeModal === "add"}
                    onHide={onClose}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <div className="h5 mb-0">
                                <i className="fad fa-plus text-primary icon"></i>{" "}
                                {t("Pages.SchoolsControl.Add")}
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="widget widget-category">
                            <div className="widget-body">
                                <EditSchoolForm
                                    isAdmin={true}
                                    onSubmit={onSubmitAdd}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}

            {/* Edit School Modal */}
            {activeModal === "edit" && selectedSchool && (
                <Modal
                    size="lg"
                    centered
                    backdrop="static"
                    keyboard={false}
                    enforceFocus={false}
                    show={activeModal === "edit"}
                    onHide={onClose}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <div className="h5 mb-0">
                                <i className="fad fa-edit text-primary icon"></i>{" "}
                                {t("Pages.SchoolsControl.action.edit")}
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="widget widget-category">
                            <div className="widget-body">
                                <EditSchoolForm
                                    isAdmin={true}
                                    isEdit={true}
                                    school={selectedSchool}
                                    onSubmit={(postData, toastId) =>
                                        onSubmitEdit(selectedSchool.Id, postData, toastId, t)
                                    }
                                />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}

            {/* Bills Modal */}
            {activeModal === "bills" && selectedSchool && (
                <UserBill
                    handleClose={onClose}
                    user={selectedSchool.SchoolUser}
                />
            )}

            {/* Notes Modal */}
            {activeModal === "notes" && selectedSchool && (
                <UserNote
                    handleClose={onClose}
                    user={selectedSchool.SchoolUser}
                />
            )}

            {/* School Details & Managers Modal */}
            {activeModal === "info" && selectedSchool && (
                <Modal
                    size="lg"
                    centered
                    show={activeModal === "info"}
                    onHide={onClose}
                    className="more-info-modal-container"
                >
                    <Modal.Header closeButton className="border-0 pb-0">
                        <Modal.Title className="w-100">
                            <div className="d-flex align-items-center">
                                <div
                                    className="more-info-icon-wrapper ml-3"
                                    style={{ color: "var(--brand-purple)" }}
                                >
                                    <i className="fad fa-school"></i>
                                </div>
                                <div className="text-right">
                                    <div className="h5 mb-1 font-weight-bold text-dark">
                                        {t("Pages.SchoolsControl.action.info")}
                                    </div>
                                    <div className="small text-muted">{selectedSchool.Name}</div>
                                </div>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pt-3 pb-4">
                        <div className="more-info-layout-wrapper">
                            <div className="more-info-main-panel">
                                {/* School Info Section */}
                                <div className="more-info-hero mb-4">
                                    <div className="hero-avatar-section">
                                        <div className="hero-avatar-wrapper position-relative">
                                            <LazyLoadImage
                                                src="/assets/images/logo/130p150.png"
                                                alt={selectedSchool.Name}
                                                className="hero-avatar-img border-active"
                                                style={{
                                                    width: "80px",
                                                    height: "80px",
                                                    borderRadius: "50%",
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="hero-details-section">
                                        <h4 className="hero-name mb-0 font-weight-bold text-dark">
                                            {selectedSchool.Name}
                                        </h4>
                                        <div className="hero-meta text-muted mt-2 d-flex align-items-center flex-wrap gap-2">
                                            <span className="hero-username">
                                                {selectedSchool.Code ? `#${selectedSchool.Code}` : ""}
                                            </span>
                                            {selectedSchool.IsLocked && (
                                                <>
                                                    <span className="hero-divider text-muted mx-1">
                                                        •
                                                    </span>
                                                    <span className="badge badge-dark px-2 py-1">
                                                        <i className="fas fa-lock ml-1"></i>{" "}
                                                        {t("Pages.UsersControl.Locked")}
                                                    </span>
                                                </>
                                            )}
                                            {selectedSchool.IsForTest && (
                                                <>
                                                    <span className="hero-divider text-muted mx-1">
                                                        •
                                                    </span>
                                                    <span className="badge badge-warning px-2 py-1 text-white">
                                                        <i className="fas fa-alarm-exclamation ml-1"></i>{" "}
                                                        {t("Pages.SchoolsControl.IsForTest")}
                                                    </span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* School Info Cards Grid */}
                                <div className="more-info-grid-modern">
                                    {/* Country */}
                                    <div className="info-detail-card-modern">
                                        <div className="info-detail-icon-modern text-info">
                                            <i className="fad fa-globe"></i>
                                        </div>
                                        <div className="info-detail-content-modern">
                                            <span className="info-detail-label-modern">
                                                {t("Pages.Register.Country.title")}
                                            </span>
                                            <span className="info-detail-value-modern">
                                                {countries.find(
                                                    (c) => c.value === selectedSchool.Country
                                                )?.name ||
                                                    selectedSchool.Country ||
                                                    t("NoInfo")}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Address */}
                                    <div className="info-detail-card-modern">
                                        <div
                                            className="info-detail-icon-modern text-purple"
                                            style={{ color: "var(--brand-purple)" }}
                                        >
                                            <i className="fad fa-map-marker-alt"></i>
                                        </div>
                                        <div className="info-detail-content-modern">
                                            <span className="info-detail-label-modern">
                                                {t("Pages.Register.Address.title")}
                                            </span>
                                            <span className="info-detail-value-modern">
                                                {selectedSchool.Address || t("NoInfo")}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Email */}
                                    <div className="info-detail-card-modern">
                                        <div className="info-detail-icon-modern text-primary">
                                            <i className="fad fa-envelope-open-text"></i>
                                        </div>
                                        <div className="info-detail-content-modern">
                                            <span className="info-detail-label-modern">
                                                {t("Pages.Register.Email.title")}
                                            </span>
                                            <span className="info-detail-value-modern">
                                                {selectedSchool.Email ? (
                                                    <a
                                                        href={`mailto:${selectedSchool.Email}`}
                                                        className="text-decoration-none text-dark hover-primary-link"
                                                    >
                                                        {selectedSchool.Email}
                                                    </a>
                                                ) : (
                                                    t("NoInfo")
                                                )}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Phone */}
                                    <div className="info-detail-card-modern">
                                        <div className="info-detail-icon-modern text-success">
                                            <i className="fad fa-phone-alt"></i>
                                        </div>
                                        <div className="info-detail-content-modern">
                                            <span className="info-detail-label-modern">
                                                {t("Pages.Register.Phone.title")}
                                            </span>
                                            <span
                                                className="info-detail-value-modern"
                                                dir="ltr"
                                                style={{ textAlign: "right" }}
                                            >
                                                {selectedSchool.Phone ? (
                                                    <a
                                                        href={`tel:${selectedSchool.Phone}`}
                                                        className="text-decoration-none text-dark hover-success-link"
                                                    >
                                                        {selectedSchool.Phone}
                                                    </a>
                                                ) : (
                                                    t("NoInfo")
                                                )}
                                            </span>
                                        </div>
                                    </div>

                                    {/* School Code */}
                                    <div className="info-detail-card-modern">
                                        <div className="info-detail-icon-modern text-info">
                                            <i className="fad fa-barcode"></i>
                                        </div>
                                        <div className="info-detail-content-modern">
                                            <span className="info-detail-label-modern">
                                                {t("Pages.UsersControl.advancedSearch.Code") || "رمز المدرسة"}
                                            </span>
                                            <span className="info-detail-value-modern font-weight-bold">
                                                {selectedSchool.Code || t("NoInfo")}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Max Teachers */}
                                    <div className="info-detail-card-modern">
                                        <div className="info-detail-icon-modern text-danger">
                                            <i className="fad fa-abacus"></i>
                                        </div>
                                        <div className="info-detail-content-modern">
                                            <span className="info-detail-label-modern">
                                                {t("Pages.Register.MaxTeacherCount.title")}
                                            </span>
                                            <span className="info-detail-value-modern">
                                                {selectedSchool.MaxTeacherCount}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Max Students */}
                                    <div className="info-detail-card-modern">
                                        <div className="info-detail-icon-modern text-danger">
                                            <i className="fad fa-graduation-cap"></i>
                                        </div>
                                        <div className="info-detail-content-modern">
                                            <span className="info-detail-label-modern">
                                                {t("Pages.Register.MaxStudentCount.title")}
                                            </span>
                                            <span className="info-detail-value-modern">
                                                {selectedSchool.MaxStudentCount}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Creation Date */}
                                    <div className="info-detail-card-modern">
                                        <div className="info-detail-icon-modern text-secondary">
                                            <i className="fad fa-calendar-plus"></i>
                                        </div>
                                        <div className="info-detail-content-modern">
                                            <span className="info-detail-label-modern">
                                                {t("Pages.Lessons.CreationDate")}
                                            </span>
                                            <span className="info-detail-value-modern">
                                                {selectedSchool.CreationDate}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Update Date */}
                                    <div className="info-detail-card-modern">
                                        <div className="info-detail-icon-modern text-secondary">
                                            <i className="fad fa-calendar-edit"></i>
                                        </div>
                                        <div className="info-detail-content-modern">
                                            <span className="info-detail-label-modern">
                                                {t("Pages.Lessons.UpdateDate")}
                                            </span>
                                            <span className="info-detail-value-modern">
                                                {selectedSchool.UpdateDate}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* School Users section */}
                                <div className="mt-5">
                                    <h5
                                        className="font-weight-bold text-dark mb-3 pb-2 text-right"
                                        style={{ borderBottom: "2px solid #e2e8f0" }}
                                    >
                                        <i className="fad fa-users-crown ml-2 text-primary"></i>
                                        {t("SchoolAdmins") || "مسؤولو المدرسة"}
                                    </h5>

                                    {loadingSchoolUsers ? (
                                        <div className="text-center py-4">
                                            <i className="fas fa-spinner fa-spin fa-2x text-primary"></i>
                                            <div className="mt-2 text-muted">
                                                {t("Pages.UsersControl.Loading")}
                                            </div>
                                        </div>
                                    ) : schoolUsers.length === 0 ? (
                                        <div className="text-center py-4 text-muted">
                                            <i className="fad fa-users-slash fa-2x mb-2 d-block"></i>
                                            {t("NoUsersFound") ||
                                                "لا يوجد مسؤولو مدرسة مسجلين حالياً"}
                                        </div>
                                    ) : (
                                        <div
                                            className="users-table-wrapper"
                                            style={{ minHeight: "auto", boxShadow: "none" }}
                                        >
                                            <div className="users-table-scroll">
                                                <table className="users-table" style={{ minWidth: "auto", width: "100%" }}>
                                                    <thead>
                                                        <tr className="text-right">
                                                            <th>
                                                                {t(
                                                                    "Pages.UsersControl.tableHeaders.name"
                                                                )}
                                                            </th>
                                                            <th>
                                                                {t(
                                                                    "Pages.UsersControl.tableHeaders.contact"
                                                                )}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {schoolUsers.map((user) => {
                                                            const userCountry = user.Country
                                                                ? configDataCountries.countries.find(
                                                                      (c) =>
                                                                          c.value.toLowerCase() ===
                                                                          user.Country.toLowerCase()
                                                                  )
                                                                : null;
                                                            return (
                                                                <tr
                                                                    key={user.Id}
                                                                    className="align-middle text-right clickable-row"
                                                                    onClick={() => onAction("adminInfo", user, t)}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    <td>
                                                                        <div className="d-flex align-items-center">
                                                                            <LazyLoadImage
                                                                                src={
                                                                                    user.Photo ||
                                                                                    "/assets/images/logo/130p150.png"
                                                                                }
                                                                                alt={user.Name}
                                                                                className={`rounded-circle ml-2 ${
                                                                                    user.IsActive
                                                                                        ? "border-active"
                                                                                        : "border-inactive"
                                                                                }`}
                                                                                style={{
                                                                                    width: "35px",
                                                                                    height: "35px",
                                                                                    objectFit:
                                                                                        "cover",
                                                                                    borderRadius:
                                                                                        "50%",
                                                                                }}
                                                                            />
                                                                            <div className="d-flex flex-column text-right">
                                                                                <span className="font-weight-bold text-dark">
                                                                                    {user.Name}
                                                                                </span>
                                                                                <span className="text-muted small">
                                                                                    @{user.Username}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="d-flex flex-column text-right">
                                                                            {user.Email ? (
                                                                                <span className="contact-link small">
                                                                                    <i className="fal fa-envelope-open-text ml-1"></i>
                                                                                    {user.Email}
                                                                                </span>
                                                                            ) : (
                                                                                "-"
                                                                            )}
                                                                            {user.Phone ? (
                                                                                <div
                                                                                    className="small mt-1"
                                                                                    dir="ltr"
                                                                                    style={{
                                                                                        textAlign:
                                                                                            "right",
                                                                                    }}
                                                                                >
                                                                                    {userCountry && (
                                                                                        <LazyLoadImage
                                                                                            src={
                                                                                                process
                                                                                                    .env
                                                                                                    .PUBLIC_URL +
                                                                                                userCountry.icon
                                                                                            }
                                                                                            alt={
                                                                                                userCountry.label
                                                                                            }
                                                                                            className="mr-1 ml-0"
                                                                                            style={{
                                                                                                width:
                                                                                                    "16px",
                                                                                                height:
                                                                                                    "11px",
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                    <span className="contact-link">
                                                                                        <i className="fal fa-phone-alt mr-1"></i>
                                                                                        {user.Phone}
                                                                                    </span>
                                                                                </div>
                                                                            ) : (
                                                                                "-"
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Sidebar: Administrative Actions Menu */}
                            <div className="more-info-sidebar-panel">
                                <div className="sidebar-section-header-modern">
                                    <i className="fad fa-sliders-h ml-2 text-primary"></i>
                                    <span>
                                        {t("Pages.UsersControl.actionsMenu") ||
                                            "خيارات التحكم والخيارات"}
                                    </span>
                                </div>

                                <div className="sidebar-actions-scroll scrollbar-custom">
                                    {/* Primary Actions Group */}
                                    <div className="sidebar-group-modern">
                                        <div className="sidebar-group-title-modern">
                                            {t(
                                                "Pages.UsersControl.advancedSearch.personalSection"
                                            ) || "خيارات المدرسة"}
                                        </div>

                                        {/* Edit School */}
                                        <button
                                            type="button"
                                            className="sidebar-action-btn-modern"
                                            onClick={() => onAction("edit", selectedSchool, t)}
                                        >
                                            <i className="far fa-edit icon text-info ml-2"></i>
                                            <span>{t("Pages.SchoolsControl.action.edit")}</span>
                                        </button>

                                        {/* Bills */}
                                        <button
                                            type="button"
                                            className="sidebar-action-btn-modern"
                                            onClick={() => onAction("bills", selectedSchool, t)}
                                        >
                                            <i className="far fa-file-invoice-dollar icon text-primary ml-2"></i>
                                            <span>{t("Pages.UsersControl.action.bills")}</span>
                                        </button>

                                        {/* Notes */}
                                        <button
                                            type="button"
                                            className="sidebar-action-btn-modern"
                                            onClick={() => onAction("notes", selectedSchool, t)}
                                        >
                                            <i
                                                className={`far fa-sticky-note icon ml-2 ${
                                                    selectedSchool.SchoolUser?.Notes > 0
                                                        ? "text-danger"
                                                        : "text-primary"
                                                }`}
                                            ></i>
                                            <span>{t("Pages.UsersControl.action.notes")}</span>
                                        </button>

                                        {/* Clear Students */}
                                        <button
                                            type="button"
                                            className="sidebar-action-btn-modern"
                                            onClick={() =>
                                                onAction("clearStudents", selectedSchool, t)
                                            }
                                        >
                                            <i className="far fa-eraser icon text-warning ml-2"></i>
                                            <span>
                                                {t("Pages.SchoolsControl.action.clearStudents")}
                                            </span>
                                        </button>

                                        {/* Delete School */}
                                        <button
                                            type="button"
                                            className="sidebar-action-btn-modern danger-btn mt-2"
                                            onClick={() => onAction("delete", selectedSchool, t)}
                                        >
                                            <i className="far fa-trash icon text-danger ml-2"></i>
                                            <span>{t("Pages.SchoolsControl.action.remove")}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}

            {/* School Admin Manager User details modal */}
            {activeAdminUser && (
                <MoreInfoModal
                    show={!!activeAdminUser}
                    onClose={() => setActiveAdminUser(null)}
                    user={activeAdminUser}
                    onAction={(action, user) => {
                        toast.info(t("ManageUsersWarning") || "يرجى إدارة المستخدمين من صفحة المستخدمين");
                    }}
                    t={t}
                />
            )}
        </>
    );
};

export default SchoolModals;
